import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap'
import { FaBus } from 'react-icons/fa'
import { LuGraduationCap } from 'react-icons/lu'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import ApiEndpoints from './commonComponents/ApiEndpoints'

export default function CreateBus() {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const navigate = useNavigate()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();

  const [form, setForm] = useState({
    busNumber: '',
    busName: '',
    driverName: '',
    driverNumber: '',
    ownerName: '',
    ownerNumber: '',
    busUser: 'All',
  })

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1
        setMarginLeft(
          isCollapsed ? `${collapsedWidth + gap}px` : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }
      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm((prev) => ({ ...prev, [name]: value }))
  }

  // const handleSubmit = (e) => {
  //   e.preventDefault()
  //   const required = [
  //     form.busNumber,
  //     form.busName,
  //     form.driverName,
  //     form.driverNumber,
  //     form.ownerName,
  //     form.ownerNumber,
  //     form.busUser,
  //   ]
  //   if (required.some((v) => !String(v).trim())) {
  //     toast.error('Please fill all required fields')
  //     return
  //   }
  //   toast.success('Bus saved (demo)')
  //   setForm({
  //     busNumber: '',
  //     busName: '',
  //     driverName: '',
  //     driverNumber: '',
  //     ownerName: '',
  //     ownerNumber: '',
  //     busUser: 'All',
  //   })
  // }

  const handleSubmit = async (e) => {
  e.preventDefault();
  // console.log("from data",form) 

  if (!form.busNumber.trim()) {
  toast.error("Bus number is required");
  return;
}
console.log("From data",form)
  
  try {
    const res = await ApiEndpoints.addBus({
      bus_name:form.busName,
      bus_number: form.busNumber,
      driver_name: form.driverName,
      driver_contact_number: form.driverNumber,
      bus_owner_name: form.ownerName,
      bus_owner_number:form.ownerNumber,
      bus_userType:form.userType,
      institute_id: id
    });

    toast.success(res?.data?.message || "Bus Added Successfully");

    // reset form
    setForm({
      busNumber: '',
      busName: '',
      driverName: '',
      driverNumber: '',
      ownerName: '',
      ownerNumber: '',
      busUser: 'All',
    });

    // navigate back to list
    navigate('/Transport');

  } catch (error) {
    console.error("APi Error", error);

    const errorData = error.response?.data;

    if (errorData?.errors && typeof errorData.errors === "object") {
      Object.values(errorData.errors).forEach((errArr) => {
        if (Array.isArray(errArr)) {
          errArr.forEach((msg) => toast.error(msg));
        } else if (errArr) {
          toast.error(String(errArr));
        }
      });
    } else if (errorData?.message) {
      toast.error(errorData.message);
    } else if (error.response) {
      toast.error("Request failed. Please try again.");
    } else {
      toast.error("Server not reachable");
    }
  }
};

  return (
    <>
      <style>
        {`
          .page-title {
            font-family: 'Inter', system-ui, sans-serif;
            letter-spacing: -0.02em;
            color: #223843;
          }
          .modern-card {
            background: #ffffff;
            border: 1px solid #D1D3D4;
            border-radius: 12px;
            overflow: hidden;
          }
          .form-control, .form-select {
            border-radius: 10px !important;
            border: 1px solid #D1D3D4 !important;
            padding: 10px 12px !important;
            font-family: 'Inter', system-ui, sans-serif;
          }
          .form-label {
            font-weight: 600;
            color: #111827;
            font-family: 'Inter', system-ui, sans-serif;
          }
        `}
      </style>

      <div
        style={{
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: '12px',
          paddingRight: '12px',
        }}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
          <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                background: '#F3F4F6',
                paddingLeft: '28px',
                paddingRight: '28px',
                paddingTop: '12px',
                paddingBottom: '12px',
                borderBottom: '1px solid #D1D3D4',
                width: '100%',
                gap: '12px',
              }}
            >
              <div className="d-flex align-items-center gap-3" style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    background: '#223843',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  {!logoError ? (
                    <img
                      src={logo}
                      alt="School Logo"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={() => setLogoError(true)}
                    />
                  ) : (
                    <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                  )}
                </div>
                <div style={{ minWidth: 0 }}>
                  <h3
                    className="m-0 fw-bold page-title"
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      fontSize: isMobile ? '14px' : 'clamp(18px, 2.5vw, 22px)',
                      lineHeight: '1.2',
                    }}
                  >
                    Add Transport
                  </h3>
                  <p
                    className="m-0 mt-0 text-start"
                    style={{ fontSize: isMobile ? '10px' : '13px', color: '#6b7280' }}
                  >
                    Fill details and submit.
                  </p>
                </div>
              </div>

              {!isMobile && (
                <ProfileDropdown logout={logout} notificationCount={3} showNotifications={true} />
              )}
            </div>
          </div>
        </div>

        <Container
          className="mt-4"
          style={{
            paddingLeft: isCollapsed ? '32px' : '40px',
            // paddingRight: '32px',
            // paddingTop: '32px',
            paddingBottom: '32px',
            maxWidth: '1200px',
          }}
        >
          <Form onSubmit={handleSubmit}>
            <Row className="g-4">
              <Col xs={12}>
                <Card
                  style={{
                    border: 'none',
                    overflow: 'hidden',
                  }}
                >
                  {/* <div
                    style={{
                      background: 'linear-gradient(135deg, #223843 0%, #223843 100%)',
                      padding: '16px 24px',
                      borderBottom: '1px solid #D1D3D4',
                    }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div
                        style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '10px',
                          backgroundColor: 'rgba(255, 255, 255, 0.2)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backdropFilter: 'blur(10px)',
                        }}
                      >
                        <FaBus size={18} style={{ color: '#ffffff' }} />
                      </div>
                      <h5
                        style={{
                          margin: 0,
                          fontWeight: '700',
                          fontSize: '16px',
                          color: '#ffffff',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        Bus Details
                      </h5>
                    </div>
                  </div> */}

                  <Card.Body style={{ padding: '24px' }} className="text-start">
                    <Row className="g-3">
                      <Col xs={12} md={6}>
                        <Form.Group>
                          <Form.Label>Vehicle Number *</Form.Label>
                          <Form.Control
                            name="busNumber"
                            value={form.busNumber}
                            onChange={handleChange}
                            placeholder="Enter bus number"
                            required
                          />
                        </Form.Group>
                      </Col>
                      {/* <Col xs={12} md={6}>
                        <Form.Group>
                          <Form.Label>Bus Name *</Form.Label>
                          <Form.Control
                            name="busName"
                            value={form.busName}
                            onChange={handleChange}
                            placeholder="Enter bus name"
                            required
                          />
                        </Form.Group>
                      </Col> */}

                      <Col xs={12} md={6}>
                        <Form.Group>
                          <Form.Label>Driver Name *</Form.Label>
                          <Form.Control
                            name="driverName"
                            value={form.driverName}
                            onChange={handleChange}
                            placeholder="Enter driver name"
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={6}>
                        <Form.Group>
                          <Form.Label>Driver Number *</Form.Label>
                          <Form.Control
                            name="driverNumber"
                            value={form.driverNumber}
                            onChange={handleChange}
                            placeholder="Enter driver number"
                            required
                          />
                        </Form.Group>
                      </Col>

                      <Col xs={12} md={6}>
                        <Form.Group>
                          <Form.Label>Owner Name *</Form.Label>
                          <Form.Control
                            name="ownerName"
                            value={form.ownerName}
                            onChange={handleChange}
                            placeholder="Enter owner name"
                            required
                          />
                        </Form.Group>
                      </Col>
                      {/* <Col xs={12} md={6}>
                        <Form.Group>
                          <Form.Label>Owner Number *</Form.Label>
                          <Form.Control
                            name="ownerNumber"
                            value={form.ownerNumber}
                            onChange={handleChange}
                            placeholder="Enter owner number"
                            required
                          />
                        </Form.Group>
                      </Col> */}

                      {/* <Col xs={12} md={6}>
                        <Form.Group>
                          <Form.Label>Bus User *</Form.Label>
                          <Form.Select
                            name="busUser"
                            value={form.busUser}
                            onChange={handleChange}
                            required
                          >
                            <option>Student</option>
                            <option>Teacher</option>
                            <option>All</option>
                          </Form.Select>
                        </Form.Group>
                      </Col> */}

                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* Action Bar (match NotificationForm) */}
            <div
              className="d-flex justify-content-end gap-3 mt-4 pt-3"
              style={{ borderTop: '1px solid #E5E7EB' }}

                //               className="d-flex gap-3 mt-4 pt-3"
                // style={{
                //   borderTop: '1px solid #E5E7EB',
                //   justifyContent: isMobile ? 'center' : 'flex-end',  // ✅ FIX
                //   flexWrap: 'wrap',                                  // ✅ FIX
                //   padding: isMobile ? '0 10px' : '0',                // ✅ FIX
                // }}
            >
              <Button
                type="button"
                onClick={() => navigate('/Transport')}
                style={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #D1D3D4',
                  color: '#6b7280',
                  borderRadius: '8px',
                  padding: '12px 24px',
                  fontWeight: '600',
                  fontSize: '15px',
                  fontFamily: 'Inter, system-ui, sans-serif',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  transition: 'all 0.2s ease',
                  minWidth: '140px',
//                   padding: isMobile ? '8px 12px' : '12px 24px',
// minWidth: isMobile ? '100%' : '140px',
// fontSize: isMobile ? '13px' : '15px',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#F3F4F6'
                  e.currentTarget.style.borderColor = '#9ca3af'
                  e.currentTarget.style.color = '#111827'
                  e.currentTarget.style.transform = 'translateY(-1px)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#ffffff'
                  e.currentTarget.style.borderColor = '#D1D3D4'
                  e.currentTarget.style.color = '#6b7280'
                  e.currentTarget.style.transform = 'translateY(0)'
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                style={{
                  backgroundColor: '#10B981',
                  border: 'none',
                  color: '#ffffff',
                  borderRadius: '8px',
                  padding: '12px 24px',
                  fontWeight: '600',
                  fontSize: '15px',
                  fontFamily: 'Inter, system-ui, sans-serif',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  transition: 'all 0.2s ease',
                  minWidth: '160px',
                  boxShadow: '0 2px 4px rgba(16, 185, 129, 0.2)',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#059669'
                  e.currentTarget.style.transform = 'translateY(-1px)'
                  e.currentTarget.style.boxShadow = '0 4px 8px rgba(16, 185, 129, 0.3)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#10B981'
                  e.currentTarget.style.transform = 'translateY(0)'
                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(16, 185, 129, 0.2)'
                }}
              >
                Submit Bus
              </Button>
            </div>
          </Form>
        </Container>
      </div>
    </>
  )
}















// import React, { useEffect, useState } from 'react'
// import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap'
// import { FaBus } from 'react-icons/fa'
// import { LuGraduationCap } from 'react-icons/lu'
// import { useAuth } from './AuthContext'
// import { useSidebar } from './SidebarContext'
// import ProfileDropdown from './commonComponents/ProfileDropdown'
// import { useInstitute } from './commonComponents/InstituteContext'
// import toast from 'react-hot-toast'
// import { useNavigate } from 'react-router-dom'

// export default function CreateBus() {
//   const { logout } = useAuth()
//   const { isCollapsed } = useSidebar()
//   const navigate = useNavigate()
//   const [marginLeft, setMarginLeft] = useState('0px')
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
//   )
//   const [logoError, setLogoError] = useState(false)
//   const { logo, name, id } = useInstitute();

//   const [form, setForm] = useState({
//     busNumber: '',
//     busName: '',
//     driverName: '',
//     driverNumber: '',
//     ownerName: '',
//     ownerNumber: '',
//     busUser: 'All',
//   })

//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth >= 992) {
//         const expandedWidth = 245
//         const collapsedWidth = 85
//         const gap = 1
//         setMarginLeft(
//           isCollapsed ? `${collapsedWidth + gap}px` : `${expandedWidth + gap}px`,
//         )
//       } else {
//         setMarginLeft('0px')
//       }
//       setIsMobile(window.innerWidth <= 768)
//     }

//     handleResize()
//     window.addEventListener('resize', handleResize)
//     return () => window.removeEventListener('resize', handleResize)
//   }, [isCollapsed])

//   const handleChange = (e) => {
//     const { name, value } = e.target
//     setForm((prev) => ({ ...prev, [name]: value }))
//   }

//   const handleSubmit = (e) => {
//     e.preventDefault()
//     const required = [
//       form.busNumber,
//       form.busName,
//       form.driverName,
//       form.driverNumber,
//       form.ownerName,
//       form.ownerNumber,
//       form.busUser,
//     ]
//     if (required.some((v) => !String(v).trim())) {
//       toast.error('Please fill all required fields')
//       return
//     }
//     toast.success('Bus saved (demo)')
//     setForm({
//       busNumber: '',
//       busName: '',
//       driverName: '',
//       driverNumber: '',
//       ownerName: '',
//       ownerNumber: '',
//       busUser: 'All',
//     })
//   }

  

//   return (
//     <>
//       <style>
//         {`
//           .page-title {
//             font-family: 'Inter', system-ui, sans-serif;
//             letter-spacing: -0.02em;
//             color: #223843;
//           }
//           .modern-card {
//             background: #ffffff;
//             border: 1px solid #D1D3D4;
//             border-radius: 12px;
//             overflow: hidden;
//           }
//           .form-control, .form-select {
//             border-radius: 10px !important;
//             border: 1px solid #D1D3D4 !important;
//             padding: 10px 12px !important;
//             font-family: 'Inter', system-ui, sans-serif;
//           }
//           .form-label {
//             font-weight: 600;
//             color: #111827;
//             font-family: 'Inter', system-ui, sans-serif;
//           }
//         `}
//       </style>

//       <div
//         style={{
//           marginLeft,
//           transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
//           willChange: 'margin-left',
//           position: 'relative',
//           zIndex: 1,
//           marginTop: '0px',
//           paddingLeft: '12px',
//           paddingRight: '12px',
//         }}
//       >
//         {/* Header */}
//         <div
//           className="container-fluid p-0"
//           style={{
//             marginTop: window.innerWidth < 992 ? '55px' : '-12px',
//             paddingLeft: '0px',
//             paddingRight: '0px',
//           }}
//         >
//           <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
//             <div
//               className="d-flex justify-content-between align-items-center"
//               style={{
//                 background: '#F3F4F6',
//                 paddingLeft: '28px',
//                 paddingRight: '28px',
//                 paddingTop: '12px',
//                 paddingBottom: '12px',
//                 borderBottom: '1px solid #D1D3D4',
//                 width: '100%',
//                 gap: '12px',
//               }}
//             >
//               <div className="d-flex align-items-center gap-3" style={{ flex: 1, minWidth: 0 }}>
//                 <div
//                   style={{
//                     width: '40px',
//                     height: '40px',
//                     borderRadius: '50%',
//                     overflow: 'hidden',
//                     background: '#223843',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     flexShrink: 0,
//                   }}
//                 >
//                   {!logoError ? (
//                     <img
//                       src={logo}
//                       alt="School Logo"
//                       style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                       onError={() => setLogoError(true)}
//                     />
//                   ) : (
//                     <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
//                   )}
//                 </div>
//                 <div style={{ minWidth: 0 }}>
//                   <h3
//                     className="m-0 fw-bold page-title"
//                     style={{
//                       overflow: 'hidden',
//                       textOverflow: 'ellipsis',
//                       whiteSpace: 'nowrap',
//                       fontSize: isMobile ? '14px' : 'clamp(18px, 2.5vw, 22px)',
//                       lineHeight: '1.2',
//                     }}
//                   >
//                     Create Bus
//                   </h3>
//                   <p
//                     className="m-0 mt-0 text-start"
//                     style={{ fontSize: isMobile ? '10px' : '13px', color: '#6b7280' }}
//                   >
//                     Fill details and submit.
//                   </p>
//                 </div>
//               </div>

//               {!isMobile && (
//                 <ProfileDropdown logout={logout} notificationCount={3} showNotifications={true} />
//               )}
//             </div>
//           </div>
//         </div>

//         <Container
//           className="mt-4"
//           style={{
//             paddingLeft: isCollapsed ? '32px' : '40px',
//             // paddingRight: '32px',
//             // paddingTop: '32px',
//             paddingBottom: '32px',
//             maxWidth: '1200px',
//           }}
//         >
//           <Form onSubmit={handleSubmit}>
//             <Row className="g-4">
//               <Col xs={12}>
//                 <Card
//                   style={{
//                     border: 'none',
//                     overflow: 'hidden',
//                   }}
//                 >
//                   {/* <div
//                     style={{
//                       background: 'linear-gradient(135deg, #223843 0%, #223843 100%)',
//                       padding: '16px 24px',
//                       borderBottom: '1px solid #D1D3D4',
//                     }}
//                   >
//                     <div className="d-flex align-items-center gap-2">
//                       <div
//                         style={{
//                           width: '36px',
//                           height: '36px',
//                           borderRadius: '10px',
//                           backgroundColor: 'rgba(255, 255, 255, 0.2)',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           backdropFilter: 'blur(10px)',
//                         }}
//                       >
//                         <FaBus size={18} style={{ color: '#ffffff' }} />
//                       </div>
//                       <h5
//                         style={{
//                           margin: 0,
//                           fontWeight: '700',
//                           fontSize: '16px',
//                           color: '#ffffff',
//                           fontFamily: 'Inter, system-ui, sans-serif',
//                         }}
//                       >
//                         Bus Details
//                       </h5>
//                     </div>
//                   </div> */}

//                   <Card.Body style={{ padding: '24px' }} className="text-start">
//                     <Row className="g-3">
//                       <Col xs={12} md={6}>
//                         <Form.Group>
//                           <Form.Label>Bus Number *</Form.Label>
//                           <Form.Control
//                             name="busNumber"
//                             value={form.busNumber}
//                             onChange={handleChange}
//                             placeholder="Enter bus number"
//                             required
//                           />
//                         </Form.Group>
//                       </Col>
//                       <Col xs={12} md={6}>
//                         <Form.Group>
//                           <Form.Label>Bus Name *</Form.Label>
//                           <Form.Control
//                             name="busName"
//                             value={form.busName}
//                             onChange={handleChange}
//                             placeholder="Enter bus name"
//                             required
//                           />
//                         </Form.Group>
//                       </Col>

//                       <Col xs={12} md={6}>
//                         <Form.Group>
//                           <Form.Label>Driver Name *</Form.Label>
//                           <Form.Control
//                             name="driverName"
//                             value={form.driverName}
//                             onChange={handleChange}
//                             placeholder="Enter driver name"
//                             required
//                           />
//                         </Form.Group>
//                       </Col>
//                       <Col xs={12} md={6}>
//                         <Form.Group>
//                           <Form.Label>Driver Number *</Form.Label>
//                           <Form.Control
//                             name="driverNumber"
//                             value={form.driverNumber}
//                             onChange={handleChange}
//                             placeholder="Enter driver number"
//                             required
//                           />
//                         </Form.Group>
//                       </Col>

//                       <Col xs={12} md={6}>
//                         <Form.Group>
//                           <Form.Label>Owner Name *</Form.Label>
//                           <Form.Control
//                             name="ownerName"
//                             value={form.ownerName}
//                             onChange={handleChange}
//                             placeholder="Enter owner name"
//                             required
//                           />
//                         </Form.Group>
//                       </Col>
//                       <Col xs={12} md={6}>
//                         <Form.Group>
//                           <Form.Label>Owner Number *</Form.Label>
//                           <Form.Control
//                             name="ownerNumber"
//                             value={form.ownerNumber}
//                             onChange={handleChange}
//                             placeholder="Enter owner number"
//                             required
//                           />
//                         </Form.Group>
//                       </Col>

//                       <Col xs={12} md={6}>
//                         <Form.Group>
//                           <Form.Label>Bus User *</Form.Label>
//                           <Form.Select
//                             name="busUser"
//                             value={form.busUser}
//                             onChange={handleChange}
//                             required
//                           >
//                             <option>Student</option>
//                             <option>Teacher</option>
//                             <option>All</option>
//                           </Form.Select>
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                   </Card.Body>
//                 </Card>
//               </Col>
//             </Row>

//             {/* Action Bar (match NotificationForm) */}
//             <div
//               className="d-flex justify-content-end gap-3 mt-4 pt-3"
//               style={{ borderTop: '1px solid #E5E7EB' }}
//             >
//               <Button
//                 type="button"
//                 onClick={() => navigate('/Transport')}
//                 style={{
//                   backgroundColor: '#ffffff',
//                   border: '1px solid #D1D3D4',
//                   color: '#6b7280',
//                   borderRadius: '8px',
//                   padding: '12px 24px',
//                   fontWeight: '600',
//                   fontSize: '15px',
//                   fontFamily: 'Inter, system-ui, sans-serif',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   gap: '8px',
//                   transition: 'all 0.2s ease',
//                   minWidth: '140px',
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.backgroundColor = '#F3F4F6'
//                   e.currentTarget.style.borderColor = '#9ca3af'
//                   e.currentTarget.style.color = '#111827'
//                   e.currentTarget.style.transform = 'translateY(-1px)'
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.backgroundColor = '#ffffff'
//                   e.currentTarget.style.borderColor = '#D1D3D4'
//                   e.currentTarget.style.color = '#6b7280'
//                   e.currentTarget.style.transform = 'translateY(0)'
//                 }}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 type="submit"
//                 style={{
//                   backgroundColor: '#10B981',
//                   border: 'none',
//                   color: '#ffffff',
//                   borderRadius: '8px',
//                   padding: '12px 24px',
//                   fontWeight: '600',
//                   fontSize: '15px',
//                   fontFamily: 'Inter, system-ui, sans-serif',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   gap: '8px',
//                   transition: 'all 0.2s ease',
//                   minWidth: '160px',
//                   boxShadow: '0 2px 4px rgba(16, 185, 129, 0.2)',
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.backgroundColor = '#059669'
//                   e.currentTarget.style.transform = 'translateY(-1px)'
//                   e.currentTarget.style.boxShadow = '0 4px 8px rgba(16, 185, 129, 0.3)'
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.backgroundColor = '#10B981'
//                   e.currentTarget.style.transform = 'translateY(0)'
//                   e.currentTarget.style.boxShadow = '0 2px 4px rgba(16, 185, 129, 0.2)'
//                 }}
//               >
//                 Submit Bus
//               </Button>
//             </div>
//           </Form>
//         </Container>
//       </div>
//     </>
//   )
// }


